import { axios } from "@/plugins/axios";
import { getDataString } from "@/utils";
import { DateFormatter } from "@/utils/date";

function checkActivationCode(activationcode, birthdate) {
    let data = {};
    data.activationcode = activationcode;
    if (birthdate.charAt(2) === ".") {
        data.birthdate = birthdate;
    } else {
        data.birthdate = DateFormatter.formatDate(
            new Date(birthdate),
            "DD.MM.YYYY"
        );
    }
    const dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=CheckActivationCode",
        dataString
    );
}

function activateEservicesAccount(data = {}) {
    if (data.birthdate.charAt(2) !== ".") {
        data.birthdate = DateFormatter.formatDate(
            new Date(data.birthdate),
            "DD.MM.YYYY"
        );
    }
    if (data.ausstellungsdatum.charAt(2) !== ".") {
        data.ausstellungsdatum = DateFormatter.formatDate(
            new Date(data.ausstellungsdatum),
            "DD.MM.YYYY"
        );
    }
    data.mobil = data.mobil.substr(1).replaceAll("/", "");
    let formData = new FormData();
    for (let key in data) {
        if (key !== "file") {
            formData.append(key, data[key]);
        }
    }
    for (let [index, file] of data.file.entries()) {
        formData.append("file-" + index, file);
    }
    return axios.post(
        "?Mode=MeinServicebereich&Function=ActivateEservicesAccount",
        formData,
        { timeout: 120 * 1000 }
    );
}

export { checkActivationCode, activateEservicesAccount };
